webpackJsonp([92],{

/***/ 1226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [],
            total: 0,
            loading: false,
            sortField: 'vote_count',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 20
        };
    },

    methods: {
        /*
        * Load async data
        */
        loadAsyncData: function loadAsyncData() {
            var _this = this;

            var params = ['api_key=bb6f51bef07465653c3e553d6ab161a8', 'language=en-US', 'include_adult=false', 'include_video=false', 'sort_by=' + this.sortField + '.' + this.sortOrder, 'page=' + this.page].join('&');

            this.loading = true;
            this.$http.get('https://api.themoviedb.org/3/discover/movie?' + params).then(function (_ref) {
                var data = _ref.data;

                // api.themoviedb.org manage max 1000 pages
                _this.data = [];
                var currentTotal = data.total_results;
                if (data.total_results / _this.perPage > 1000) {
                    currentTotal = _this.perPage * 1000;
                }
                _this.total = currentTotal;
                data.results.forEach(function (item) {
                    item.release_date = item.release_date.replace(/-/g, '/');
                    _this.data.push(item);
                });
                _this.loading = false;
            }).catch(function (error) {
                _this.data = [];
                _this.total = 0;
                _this.loading = false;
                throw error;
            });
        },

        /*
        * Handle page-change event
        */
        onPageChange: function onPageChange(page) {
            this.page = page;
            this.loadAsyncData();
        },

        /*
        * Handle sort event
        */
        onSort: function onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.loadAsyncData();
        },

        /*
        * Type style in relation to the value
        */
        type: function type(value) {
            var number = parseFloat(value);
            if (number < 6) {
                return 'is-danger';
            } else if (number >= 6 && number < 8) {
                return 'is-warning';
            } else if (number >= 8) {
                return 'is-success';
            }
        }
    },
    filters: {
        /**
        * Filter to truncate string, accepts a length parameter
        */
        truncate: function truncate(value, length) {
            return value.length > length ? value.substr(0, length) + '...' : value;
        }
    },
    mounted: function mounted() {
        this.loadAsyncData();
    }
});

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "loading": _vm.loading,
      "paginated": "",
      "backend-pagination": "",
      "total": _vm.total,
      "per-page": _vm.perPage,
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page",
      "backend-sorting": "",
      "default-sort-direction": _vm.defaultSortOrder,
      "default-sort": [_vm.sortField, _vm.sortOrder]
    },
    on: {
      "page-change": _vm.onPageChange,
      "sort": _vm.onSort
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "original_title",
            "label": "Title",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.original_title) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "vote_average",
            "label": "Vote Average",
            "numeric": "",
            "sortable": ""
          }
        }, [_c('span', {
          staticClass: "tag",
          class: _vm.type(props.row.vote_average)
        }, [_vm._v("\n                        " + _vm._s(props.row.vote_average) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "vote_count",
            "label": "Vote Count",
            "numeric": "",
            "sortable": ""
          }
        }, [_vm._v("\n                     " + _vm._s(props.row.vote_count) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "release_date",
            "label": "Release Date",
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.release_date ? new Date(props.row.release_date).toLocaleDateString() : '') + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Overview",
            "width": "500"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("truncate")(props.row.overview, 80)) + "\n                ")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1226),
  /* template */
  __webpack_require__(1227),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/92.ff35a360a8c927dfe797.js